import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { injectIntl, defineMessages } from 'react-intl';
import { Button } from 'primereact/button';
import PropTypes from 'prop-types';
import HintsCS from './components/HintsCs';
import HintsSJL from './components/HintsSJL';
import HintsJPS from './components/HintsJPS';
import ArrayUtil from '../../../../utils/ArrayUtil';
import Boundary from '../../../../components/ErrorBoundary';
import './hint-style.css';
import { intlShape } from '../../../../components/prop-types';

const messages = defineMessages({
  suggestJobProfile: { id: 'actions.suggestJobProfile', defaultMessage: 'Suggest Job Profile' },
});

const handleRequestSucceed = (response) => {
  Promise.resolve(response);
};

const handleRequestFailed = (error) => {
  if (error && ArrayUtil.isNotEmpty(error.graphQLErrors)) {
    Promise.reject(error.graphQLErrors);
  } else {
    Promise.reject();
  }
};

class JobProfileHintsContainer extends Component {
  constructor(props) {
    super(props);
    this.handleSearchRespondent = this.handleSearchRespondent.bind(this);
    this.handleSearchStandardJobs = this.handleSearchStandardJobs.bind(this);
  }

  async handleSearchRespondent(query) {
    const { respondentsCS } = this.props;
    await respondentsCS.searchRespondents(query).then(handleRequestSucceed, handleRequestFailed);
  }

  async handleSearchStandardJobs(query) {
    const { jobProfileSJL } = this.props;
    await jobProfileSJL.searchStandardJobs(query).then(handleRequestSucceed, handleRequestFailed);
  }

  render() {
    const {
      jobId,
      onSuggestJobProfile,
      dataLoading,
      selectedHints,
      nameJobProfile,
      jobProfile,
      intl: { formatMessage },
    } = this.props;
    const { standardJobProfileNumber, isUsingTopPerformerHints, isUsingJobProfileSurveyHints } = selectedHints;
    const isHintSelected = standardJobProfileNumber || isUsingTopPerformerHints || isUsingJobProfileSurveyHints;
    const {
      hintsCS,
      onHintsSJL,
      hintsJPS,
      intl: { locale },
    } = this.props;
    const preferedLocale = locale;
    const {
      onToggleJPS, onHintsJPS, onAddCSRespondent, onToggleCS, onHintsCS,
    } = this.props;
    return (
      <div>
        <Boundary>
          <HintsCS
            onAdd={onAddCSRespondent}
            onSearch={this.handleSearchRespondent}
            onToggle={onToggleCS}
            onHints={onHintsCS}
            hintsCS={hintsCS}
            isShowHint={isUsingTopPerformerHints}
            {...this.props}
            jobId={jobId}
          />
        </Boundary>
        <Boundary>
          <HintsSJL
            onHints={onHintsSJL}
            onSearchStandardJobs={this.handleSearchStandardJobs}
            jobProfile={jobProfile}
          />
        </Boundary>
        <Boundary>
          <HintsJPS
            onSearch={this.handleSearchRespondent}
            onToggle={onToggleJPS}
            onHints={onHintsJPS}
            hintsJPS={hintsJPS}
            isShowHint={isUsingJobProfileSurveyHints}
            preferedLocale={preferedLocale}
            {...this.props}
            jobId={jobId}
            nameJobProfile={nameJobProfile}
          />
        </Boundary>
        <div className="align-center">
          <Button
            type="button"
            label={formatMessage(messages.suggestJobProfile)}
            disabled={dataLoading || !isHintSelected}
            onClick={onSuggestJobProfile}
          />
        </div>
      </div>
    );
  }
}

JobProfileHintsContainer.propTypes = {
  jobProfile: PropTypes.objectOf(PropTypes.any).isRequired,
  selectedHints: PropTypes.objectOf(PropTypes.any).isRequired,
  respondentsCS: PropTypes.objectOf(PropTypes.any),
  jobProfileSJL: PropTypes.objectOf(PropTypes.any),
  nameJobProfile: PropTypes.string.isRequired,
  jobId: PropTypes.string.isRequired,
  dataLoading: PropTypes.bool.isRequired,
  onSuggestJobProfile: PropTypes.func.isRequired,
  hintsCS: PropTypes.arrayOf(PropTypes.any),
  onHintsSJL: PropTypes.func.isRequired,
  hintsJPS: PropTypes.arrayOf(PropTypes.any),
  onAddCSRespondent: PropTypes.func.isRequired,
  onToggleCS: PropTypes.func.isRequired,
  onHintsCS: PropTypes.func.isRequired,
  onToggleJPS: PropTypes.func.isRequired,
  onHintsJPS: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

JobProfileHintsContainer.defaultProps = {
  respondentsCS: null,
  jobProfileSJL: null,
  hintsCS: [],
  hintsJPS: [],
};

export default injectIntl(
  withRouter(
    JobProfileHintsContainer,
  ),
);
